import { render, staticRenderFns } from "./PrivatePayments.vue?vue&type=template&id=74f4c124&scoped=true&"
import script from "./PrivatePayments.vue?vue&type=script&lang=js&"
export * from "./PrivatePayments.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePayments.vue?vue&type=style&index=0&id=74f4c124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4c124",
  null
  
)

export default component.exports